// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
import {
  ConfigProvider,
  App,
} from 'antd';
import { ApplyPluginsType } from 'umi';
import { getPluginManager } from '../core/plugin';
import { AntdConfigContext, AntdConfigContextSetter } from './context';
import merge from '/Users/yangfan/partJob/yyzhhpt-web/node_modules/lodash/merge'

let cacheAntdConfig = null;

const getAntdConfig = () => {
  if(!cacheAntdConfig){
    cacheAntdConfig = getPluginManager().applyPlugins({
      key: 'antd',
      type: ApplyPluginsType.modify,
      initialValue: {
        ...{"theme":{"cssVar":true,"token":{"fontFamily":"AlibabaSans, sans-serif","colorText":"rgba(0, 0, 0, 0.88)","colorTextSecondary":"rgba(0, 0, 0, 0.65)"},"components":{"Menu":{"fontSize":15,"itemFontSize":14,"itemFontWeight":500,"colorItemText":"rgba(0, 0, 0, 0.95)","colorItemTextSelected":"#31a17d","colorItemTextHover":"#31a17d","fontWeight":500,"backgroundColor":"red"},"Table":{"borderRadius":0,"colorBorderSecondary":"#bebebe","paddingContentVerticalLG":8,"cellPaddingBlock":8,"cellPaddingBlockMD":6,"cellPaddingBlockSM":4,"fontSize":14},"Form":{"labelColor":"rgba(0, 0, 0, 0.85)","verticalLabelPadding":"0 0 4px","itemMarginBottom":8,"labelFontSize":14,"borderRadius":0},"Input":{"colorBorder":"#bebebe"},"Select":{"colorBorder":"#bebebe"},"DatePicker":{"colorBorder":"#bebebe"},"InputNumber":{"colorBorder":"#bebebe"},"TimePicker":{"colorBorder":"#bebebe"},"Transfer":{"colorBorder":"#b5b5b5"},"TreeSelect":{"colorBorder":"#b5b5b5"}}}},
        appConfig: {},
      },
    });
    if (!cacheAntdConfig.theme) {
      cacheAntdConfig.theme = {};
    }
  }
  return cacheAntdConfig;
}

function AntdProvider({ children }) {
  let container = children;

  const [antdConfig, _setAntdConfig] = React.useState(() => {
    const {
      appConfig: _,
      ...finalConfigProvider
    } = getAntdConfig();
    return finalConfigProvider
  });
  const setAntdConfig: typeof _setAntdConfig = (newConfig) => {
    _setAntdConfig(prev => {
      return merge({}, prev, typeof newConfig === 'function' ? newConfig(prev) : newConfig)
    })
  }


  if (antdConfig.prefixCls) {
    ConfigProvider.config({
      prefixCls: antdConfig.prefixCls,
    });
  };

  if (antdConfig.iconPrefixCls) {
    // Icons in message need to set iconPrefixCls via ConfigProvider.config()
    ConfigProvider.config({
      iconPrefixCls: antdConfig.iconPrefixCls,
    });
  };

  if (antdConfig.theme) {
    // Pass config theme to static method
    ConfigProvider.config({
      theme: antdConfig.theme,
    });
  }

  container = <ConfigProvider {...antdConfig}>{container}</ConfigProvider>;


  container = (
    <AntdConfigContextSetter.Provider value={setAntdConfig}>
      <AntdConfigContext.Provider value={antdConfig}>
        {container}
      </AntdConfigContext.Provider>
    </AntdConfigContextSetter.Provider>
  )

  return container;
}

export function rootContainer(children) {
  return (
    <AntdProvider>
      {children}
    </AntdProvider>
  );
}

// The App component should be under ConfigProvider
// plugin-locale has other ConfigProvider
export function innerProvider(container: any) {
  const {
    appConfig: finalAppConfig = {},
  } = getAntdConfig();
  return <App {...finalAppConfig}>{container}</App>;
}
